import { ChecklistComponent } from './checklist.component';

export const ChecklistModule = angular
  .module('sfMobile.components.checklist', [])
  .component('sfChecklist', ChecklistComponent).name;
